/* Среда раздела: ядро прототипа (BotCore), крючки страницы от каркаса (ui), задания и состояние. Заполняется installRewards() —
   на том месте порядка скриптов, где стоял bot-rewards.js (после steos-ui.js и bot-core.js). */
import { mutableStore, type MutableStore } from '../../state/store';
import { buildTasks, calc, initialState, type Calc, type RewardsState, type Task } from './data';

export interface Runtime {
  BC: BotCoreApi;
  ui: BotPageUi;
  TASKS: Task[];
  store: MutableStore<RewardsState>;
  c: Calc;
  /** Раздел на экране (флаг mounted прототипа) */
  mounted: boolean;
  /** Что «выскакивает» в строке задания после её перерисовки: id → селектор */
  popAfter: Map<string, string>;
}

let rt: Runtime | null = null;

export function createRuntime(): Runtime {
  const BC = window.BotCore;
  const TASKS = buildTasks(BC);
  const store = mutableStore(initialState());
  rt = { BC, ui: BC.uiDefaults(), TASKS, store, c: calc(store.S, TASKS, BC), mounted: false, popAfter: new Map() };
  return rt;
}

export function getRt(): Runtime {
  if (!rt) throw new Error('«Награды»: installRewards() не вызван');
  return rt;
}

/** Значок по имени: реестр страницы, иначе ядро */
export const icon = (r: Runtime, n: string) => r.ui.I?.[n] || r.BC.ic(n);
